var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "connection" },
    [
      _c("preloader", {
        staticClass: "preloader",
        attrs: { display: _vm.loading }
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", [
            _c(
              "p",
              { staticClass: "typographies-paragraph-medium-bold title" },
              [_vm._v("Connexion")]
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: {
                  id: "staffConnection",
                  name: "staffConnection",
                  action: "#",
                  method: "POST",
                  target: "_blank"
                }
              },
              [
                _vm.showConsentFeatures
                  ? _c(
                      "div",
                      [
                        _c("input", {
                          attrs: { type: "hidden", name: "mode", value: "saas" }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "hash" },
                          domProps: { value: _vm.connectionSelectModel }
                        }),
                        _vm._v(" "),
                        _vm.hasActiveConsents || _vm.hasPendingConsents
                          ? _c(
                              "CompassSelect",
                              {
                                staticClass: "connection__select",
                                attrs: {
                                  placeholder: _vm.hasPendingConsents
                                    ? _vm.$l10n.__("Aucune autorisation active")
                                    : "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.connectionSelectModel,
                                  callback: function($$v) {
                                    _vm.connectionSelectModel = $$v
                                  },
                                  expression: "connectionSelectModel"
                                }
                              },
                              [
                                _vm.hasPendingConsents
                                  ? _c(
                                      "CompassOptionGroup",
                                      {
                                        attrs: {
                                          label: _vm.$t.__(
                                            "common.labels.access_awaiting_authorization"
                                          )
                                        }
                                      },
                                      _vm._l(
                                        _vm.filteredStaff.pending,
                                        function(option) {
                                          return _c(
                                            "CompassDropdownSelectOption",
                                            {
                                              key: option.value,
                                              attrs: {
                                                value: option.value,
                                                label: option.label,
                                                avatar: option.avatar,
                                                labelCaption:
                                                  option.labelCaption,
                                                type: "avatar",
                                                disabled: true
                                              }
                                            }
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasActiveConsents
                                  ? _c(
                                      "CompassOptionGroup",
                                      {
                                        attrs: {
                                          label: _vm.$t.__(
                                            "sellsyadmin.Connection.authorized_access"
                                          )
                                        }
                                      },
                                      _vm._l(_vm.filteredStaff.active, function(
                                        option
                                      ) {
                                        return _c(
                                          "CompassDropdownSelectOption",
                                          {
                                            key: option.value,
                                            attrs: {
                                              value: option.value,
                                              label: option.label,
                                              avatar: option.avatar,
                                              labelCaption: option.labelCaption,
                                              caption: option.caption,
                                              type: "avatar"
                                            }
                                          }
                                        )
                                      }),
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _c("div", { staticClass: "connection__empty" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "typographies-paragraph-medium-regular"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$l10n.__("Aucun accès disponible")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                      ],
                      1
                    )
                  : _c("div", [
                      _c("input", {
                        attrs: { type: "hidden", name: "mode", value: "saas" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group form-group-block",
                          staticStyle: { "margin-bottom": "5px" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "form-input",
                              staticStyle: { display: "block" }
                            },
                            [
                              _c(
                                "select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { name: "hash" }
                                },
                                _vm._l(_vm.staffsData, function(
                                  staff,
                                  staffIndex
                                ) {
                                  return staff.status != "deleted" &&
                                    staff.corpid == _vm.corporationid
                                    ? _c(
                                        "option",
                                        {
                                          key: staffIndex,
                                          domProps: {
                                            value: staff.hash,
                                            selected:
                                              staff.staffid ===
                                              _vm.selectedStaff.staffid
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.fullname(staff)) +
                                              " - [STAFFID " +
                                              _vm._s(staff.staffid) +
                                              "]\n                            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                0
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "connection__actions" },
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__("sellsyadmin.Connection.saas"),
                              type: "secondary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.connection("saas")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__("sellsyadmin.Connection.mobile"),
                              type: "secondary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.connection("mobilev2")
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                _vm._v(" "),
                _vm.showConsentFeatures && _vm.hasActiveConsents
                  ? _c(
                      "div",
                      { staticClass: "connection__actions" },
                      [
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__("sellsyadmin.Connection.saas"),
                            type: "secondary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.connection("saas")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__("sellsyadmin.Connection.mobile"),
                            type: "secondary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.connection("mobilev2")
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showConsentFeatures && _vm.showConsentRequest
        ? [
            _c("span", { staticClass: "divider" }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("sellsyadmin.Connection.access_request"),
                disabled: !_vm.showConsentRequest
              },
              on: { click: _vm.handleConsentDemandDialog }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }